import React from 'react';
import ReactImageLoad from 'react-load-image';
import ImageRefresher from './ImageRefresher';

import ImageViewer from '../../components/ImageViewer';

// const image = props.image;
const StaticImage = props => <img src={props.src} alt={props.alt} {...props.imageAttrs} />;
const RenderActualComponent = props => (
  <props.component
    src={props.src}
    alt={props.alt}
    imageAttrs={props.imageAttrs}
    /* src={props.src}
    className="figure-image__image" */
  />
);
/* <props.component
    image={{
      src: props.src,
      alt: props.alt || props.title,
      className: 'figure-image__image',
    }}
    zoomImage={{
      className: 'figure-image__image--zoom'
    }}
    shouldRespectMaxDimension={true}
  /> */
const renderImageComponent = (Component, props) => imageUrl => (
  <ReactImageLoad src={imageUrl}>
    <RenderActualComponent component={Component} {...props} />
    <div>error loading image</div>
    <img
      src={props.placeHolder}
      alt={props.alt || props.title}
      style={{
        maxWidth: '100%',
        width: '100%',
        height: '100%',
        display: 'block',
        filter: 'blur(10px)'
      }}
    />
  </ReactImageLoad>
);

export default (props) => {
  const title = props.title;
  const alt = props.alt;

  const enableZoom = props.enableZoom;
  const ImageComponent = enableZoom ? ImageViewer : StaticImage;

  return (
    <figure className="figure-image" title={title || alt}>
      <ImageRefresher imageUrl={props.src}>
        {renderImageComponent(ImageComponent, props)}
      </ImageRefresher>
    </figure>
  );
};
